import axios from 'axios';
import config from '../config/config';

const FALLBACK_CONFIG = {
  auth: { tokenKey: 'authToken', refreshTokenKey: 'refreshToken', userKey: 'user' },
  app: { loginRoute: '/login' },
  api: { baseURL: 'http://localhost:5000/api/v1' },
};

const currentConfig = config || FALLBACK_CONFIG;

let isRefreshing = false;
let pendingQueue: Array<{ resolve: (token: string) => void; reject: (err: unknown) => void }> = [];

function processQueue(error: unknown, token: string | null) {
  pendingQueue.forEach(({ resolve, reject }) => {
    if (token) resolve(token);
    else reject(error);
  });
  pendingQueue = [];
}

function getV1AuthBaseURL(): string {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL.replace('/api/v2', '/api/v1');
  }
  if (currentConfig.api?.baseURL) {
    return currentConfig.api.baseURL.replace('/api/v2', '/api/v1');
  }
  return FALLBACK_CONFIG.api.baseURL;
}

function clearAuthStorage() {
  localStorage.removeItem(currentConfig.auth.tokenKey);
  localStorage.removeItem(currentConfig.auth.refreshTokenKey);
  localStorage.removeItem(currentConfig.auth.userKey);
}

/** Обновляет access token через api/v1/auth/refresh. Один refresh на все axios-инстансы. */
export async function refreshAccessToken(): Promise<string> {
  if (isRefreshing) {
    return new Promise((resolve, reject) => {
      pendingQueue.push({ resolve, reject });
    });
  }

  isRefreshing = true;

  try {
    const refreshToken = localStorage.getItem(currentConfig.auth.refreshTokenKey);
    if (!refreshToken) {
      throw new Error('no refresh token');
    }

    const { data } = await axios.post(`${getV1AuthBaseURL()}/auth/refresh`, { refreshToken });

    if (!data?.success || !data.accessToken) {
      throw new Error('refresh failed');
    }

    localStorage.setItem(currentConfig.auth.tokenKey, data.accessToken);
    localStorage.setItem(currentConfig.auth.refreshTokenKey, data.refreshToken);
    localStorage.setItem(currentConfig.auth.userKey, JSON.stringify(data.user));

    processQueue(null, data.accessToken);
    return data.accessToken;
  } catch (error) {
    processQueue(error, null);
    clearAuthStorage();
    window.location.href = currentConfig.app.loginRoute;
    throw error;
  } finally {
    isRefreshing = false;
  }
}
